import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import Icon from "../../../../components/Icon";
import useIntakeFormStore from "../../../../store/IntakeForm.store";

const CashTaxLotDisclosure = () => {


  const { register, control, getValues, setValue, setError, clearErrors } = useFormContext();
  const [formOptions] = useIntakeFormStore((state) => [state.data.formOptions]);

  const watchCategoryField = useWatch("selectCategory");
  const watchStrategyFields =  useWatch("selectStrategy");

  const [category, setCategory] = useState(null);
  const [strategy, setStrategy] = useState(null);
  const [assetClass, setAssetClass] = useState(null);

  useEffect(() =>{
    const allFormValues = getValues();
    setCategory(allFormValues.selectCategory);
    setStrategy(allFormValues.selectStrategy);
  },[watchCategoryField, watchStrategyFields]);

  useEffect(() => {
    setAssetClass(formOptions.strategyDetails.find(
      (strat) => strat.sector === category && strat.strategyCode === strategy
    )?.assetClass)
  }, [category, strategy])

  return (
    <>
      {assetClass && assetClass === "Equity" &&
        <>
          <div className="disclosures--info">
            <h4 className="disclosures--info__title">
              <Icon className="" name="system-warning" size="small" />
              IMPORTANT
            </h4>
            <div className="disclosures--info__content">
              <p>
                <b>Domestic Equity Strategies:</b> For the purpose of transition requests, acceptable securities include domestic common stocks (including fractionals) and a select list of equity ETFs and mutual funds. All other securities will be treated as cash and invested toward the target model portfolio. The aforementioned securities are assumed to be liquidated based on the previous close price. Actual securities accepted or rejected at account inception are at the discretion of the manager. Allspring does not guarantee that securities received in-kind can be liquidated and reserves the right to reject securities during the in-kind transfer account funding process.
              </p>
              <br />
              <p>
                <b>International/Global Equity Strategies:</b> For the purpose of transition requests, acceptable securities include domestic common stocks and international ADRs (including fractionals) and a select list of equity ETFs and mutual funds. All other securities will be treated as cash and invested toward the target model portfolio. The aforementioned securities are assumed to be liquidated based on the previous close price. Actual securities accepted or rejected at account inception are at the discretion of the manager. Allspring does not guarantee that securities received in-kind can be liquidated and reserves the right to reject securities during the in-kind transfer account funding process.
              </p>
            </div>
          </div>
        </>
      }
      
      {assetClass && watchCategoryField && watchCategoryField.selectCategory && assetClass !== "Equity" && watchCategoryField.selectCategory === "Municipal Bonds" &&
        <div className="disclosures--info">
          <h4 className="disclosures--info__title">
            <Icon className="" name="system-warning" size="small" />
            IMPORTANT
          </h4>
          <div className="disclosures--info__content">
            <p>
            For the purpose of transition requests, any matured/called bonds, zero coupon bonds, and securities of a different issue type than are held in the strategy will be treated as cash and invested toward the target model portfolio. Matured/called bonds are assumed to be liquidated based on par value. Other securities, including but not limited to zero coupon bonds, corporate bonds, treasury bonds, and equities (individual stock, mutual funds, and ETFs) are assumed to be liquidated based on the market value of the security and reinvested in the targeted strategy. Please note, any bonds issued by Puerto Rico or Guam and securitized bonds are removed from the proposal because we do not have the ability to transact in these securities. Other securities may be rejected and removed from the proposal on a case-by-case basis based on Allspring's ability to transact in these securities.
            </p>
            <br />
            <p>
            Actual securities accepted or rejected at account inception are at the discretion of the manager. Allspring does not guarantee that securities received in-kind can be liquidated and reserves the right to reject securities during the in-kind transfer account funding process.
            </p>
            <br />
            <p>Please enter adjusted cost basis in USD.</p>
          </div>
        </div>
      }

      {assetClass && watchCategoryField && watchCategoryField.selectCategory && (assetClass !== "Equity" && watchCategoryField.selectCategory === "Corporate Bonds" || watchCategoryField.selectCategory === "Treasury Bonds") &&
        <div className="disclosures--info">
          <h4 className="disclosures--info__title">
            <Icon className="" name="system-warning" size="small" />
            IMPORTANT
          </h4>
          <div className="disclosures--info__content">
            <p>
            For the purpose of transition requests, any matured/called bonds, zero coupon bonds, and securities of a different issue type than are held in the strategy will be treated as cash and invested toward the target model portfolio. Matured/called bonds are assumed to be liquidated based on par value. Other securities, including but not limited to zero coupon bonds, municipal bonds, treasury bonds, corporate bonds, securitized bonds, and equities (individual stock, mutual funds, and ETFs) are assumed to be liquidated based on the market value of the security and reinvested in the targeted strategy. Please note, any bonds issued by Puerto Rico or Guam are removed from the proposal because we do not have the ability to transact in these securities. Other securities may be rejected and removed from the proposal on a case-by-case basis based on Allspring's ability to transact in these securities.
            </p>
            <br />
            <p>
            Actual securities accepted or rejected at account inception are at the discretion of the manager. Allspring does not guarantee that securities received in-kind can be liquidated and reserves the right to reject securities during the in-kind transfer account funding process.
            </p>
            <br />
            <p>Please enter adjusted cost basis in USD.</p>
          </div>
        </div>
      }
    </>
  )
} 

export default CashTaxLotDisclosure;
